import { mapGetters } from 'vuex'
import session from '@/utilities/session.js'

export default {
  name: 'TheNavbar',
  data () {
    return {
      burgerMenuActive: false,
      expenseMenuActive: false,
      incomeMenuActive: false,
      accountMenuActive: false
    }
  },
  methods: {
    expandBurgerMenu () {
      this.burgerMenuActive = !this.burgerMenuActive
    },
    expandExpenseMenu () {
      this.expenseMenuActive = !this.expenseMenuActive
    },
    expandIncomeMenu () {
      this.incomeMenuActive = !this.incomeMenuActive
    },
    expandAccountMenu () {
      this.accountMenuActive = !this.accountMenuActive
    },
    signOut () {
      session.deleteSession()
    }
  },
  computed: {
    ...mapGetters([
      'companyName',
      'userName',
      'signedIn'
    ])
  }
}
